// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetWebAppointmentListRequestModel from '../../model/get-web-appointment-list-request-model';
import GetWebAppointmentListRequestDTO from '../dto/get-web-appointment-list-request-dto';
import dtoSchema from '../schemas/get-web-appointment-list-request-schema';

export default abstract class GetWebAppointmentListRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetWebAppointmentListRequestDTO>) {
    super();
    if (data) {
      this.organisationId = data.organisationId;
      this.year = data.year;
    }
  }
  /**
  * @type {uuid}
  */
  organisationId?: string;
  /**
  * @type {int32}
  */
  year?: number;

  static toModel(dto: DeepPartial<GetWebAppointmentListRequestDTO>): GetWebAppointmentListRequestModel;
  static toModel(dto: DeepPartial<GetWebAppointmentListRequestDTO> | undefined | null): GetWebAppointmentListRequestModel | undefined;
  static toModel(dto: DeepPartial<GetWebAppointmentListRequestDTO> | undefined | null): GetWebAppointmentListRequestModel | undefined {
    return dto ? new GetWebAppointmentListRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetWebAppointmentListRequestModel> | GetWebAppointmentListRequestModel): GetWebAppointmentListRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      organisationId: unwrapped.organisationId,
      year: unwrapped.year,
    } as GetWebAppointmentListRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetWebAppointmentListRequestModel, can not map to GetWebAppointmentListRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
